import React from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import type { ButtonProps } from '@material-ui/core/Button'

import { useMediaQuery, useTheme } from '@material-ui/core'

import { useNotificationsStyles } from './notification-list.styles'
import { NotificationTabContent } from '../common'
import { useTranslation } from '../../../utils'
import { useRouter } from 'next/router'
import { SERVICES_URL } from '@plandi/common'

type NotificationListProps = {
  settingsButtonProps?: ButtonProps
}

export const NotificationList: React.FC<NotificationListProps> = (props) => {
  const classes = useNotificationsStyles()
  const theme = useTheme()
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const { data: translation } = useTranslation()
  const { locale } = useRouter()
  const url = SERVICES_URL
  const settingUrl =
    locale === 'ru'
      ? `${url.main}/ru/profile/notifications-settings`
      : `${url.main}/profile/notifications-settings`

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography variant="h4" component="h1" className={classes.title}>
          {translation?.notifications?.['notifications-title']}
        </Typography>
        <Button
          color="secondary"
          variant="contained"
          // href="/profile/notifications-settings"
          href={settingUrl}
          className={classes.button}
          {...props.settingsButtonProps}
        >
          {translation?.menu?.settings}
          {!isMobileScreen && ' '}
          {!isMobileScreen && translation?.notices}
        </Button>
      </div>
      <div className={classes.root}>
        <NotificationTabContent
          tabClassName={classes.tab}
          tabPanelClassName={classes.tabPanel}
          notificationsPage
          className={classes.tabContainer}
        />
      </div>
    </>
  )
}
